<template>
    <div class="table-view">
        <a-table :columns="cols" :dataSource="rows" :pagination="false" />
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "TableView",

    props: {
        cols: {
            type: Array,
            required: true,
        },
        rows: {
            type: Array,
            required: true,
        },
    },
});
</script>
